<template>
  <div class="home">
    This Is Home.vue
  </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>

<style lang="scss" scoped>
.home {
  padding-top: 70px;
}
</style>
